import React from "react";
import CustomCursor from "../../Global/Cursor";
import Preloader from '../../Global/Preloader'
import Header from "../../Global/Header1";
import Pageheader from "../../Global/Pageheader";
import Aboutone from "../MenAboutus/Aboutone";
import WhyChouseone from "../MenAboutus/Whychoosetwo";
import Teamone from "../MenAboutus/Teamone";
import Testimonialone from "../MenAboutus/Testimonialone";
import WhyChooseFiveTwo from "../MenAboutus/WhyChooseFiveTwo";
import WhyChooseFour from "../MenAboutus/WhyChooseFour";
import Cta from "../../Global/Cta";
import Footer from "../../Global/Footer1";
import BackToTop from "../../Global/GoToTop";


const Main = () => {
    return (

        <>
            <CustomCursor />
            <Preloader />
            <Header />
            <Pageheader Title="About Us" subtitle="About Us" />
            <Aboutone />
            <WhyChouseone />
            <Teamone />
            <Testimonialone />
            <WhyChooseFiveTwo />
            <WhyChooseFour />
            <Cta />
            <Footer />
            <BackToTop />
        </>

    )



}
export default Main;